<template>
    <RentalsListingsShell>

        <CardShell>

            <!-- heading -->
            <CustomHeading
                headingText="Active Listings"
                linkText="My Rentals & Listings"
                route="/rentals-listings-mobile"
                :count="deactiveListingsCount"
                :forwardRoute="hasDeactivatedTools ? '/deactive-listings' : ''"
                forwardText="Deactivated"
            />

            <HugeSpinner v-if="loading"/>

            <!-- content -->
            <div v-else>
                <EmptyCard
                    v-if="!listings" 
                    class="w-70 pv4" 
                    :image="require(`@/assets/img/graphic_barricade_black.svg`)"
                    description="You don't have any tools or equipment listed."
                />
                <ListingList v-else :imageLarge="['sm', 'lg']" route="active-listing"  :tools="listings" />
            </div>

        </CardShell>

        <!-- listing pointer -->
        <GetStarted v-if="!listings && !loading"/>
        
        <SingleButtonActionbar text="Add a New Listing" @click="$router.push('/listing-start')" />

    </RentalsListingsShell>
</template>

<script>
import RentalsListingsShell from '@/components/rentalsListings/shared/RentalsListingsShell.vue';
import CardShell from '@/components/global/CardShell.vue';
import CustomHeading from '@/components/rentalsListings/activeListings/activeListingsList/CustomHeading.vue';
import EmptyCard from '@/components/global/EmptyCard.vue';
import ListingList from '@/components/global/ListingList.vue';
import GetStarted from '@/components/rentalsListings/activeListings/activeListingsList/GetStarted.vue';
import SingleButtonActionbar from '@/components/global/SingleButtonActionbar.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            hasDeactivatedTools: true
        };
    },
    components: {
        RentalsListingsShell,
        CardShell,
        CustomHeading,
        EmptyCard,
        ListingList,
        GetStarted,
        HugeSpinner,
        SingleButtonActionbar
    },
    computed: {
        ...mapState('activeListings', ['listings', 'loading']),
        ...mapState('deactiveListings', [
            'deactiveListings',
            'loadingDeactiveListings'
        ]),
        ...mapGetters('deactiveListings', ['deactiveListingsCount']),
        xs() {
            return this.$mq === 'xs';
        }
    },
    methods: {
        ...mapActions('deactiveListings', ['getDeactiveListings'])
    },
    created: function() {
        this.getDeactiveListings();
    }
};
</script>
